import { all, fork } from 'redux-saga/effects';
import fetch from './fetch';

export default function* creditCard() {
  yield all([fork(fetch)]);
}
